import React from 'react';
import { connect } from "react-redux";
import {withRouter, NavLink, Link} from 'react-router-dom'
import TextTranslate from '../../TextTranslate/TextTranslate';
import './footer.scss';

const Footer = ({contactPage = '/contact', ...props}) => {

    return (
        <footer className="container-fluid container-footer">
            <div className="row pt-4 pb-4">
                <div className="col-12 text-center">
                    <ul className="list-unstyled footer-menu">
                        {/* <li>
                            <NavLink
                                activeClassName="active"
                                to="/terms">
                                <TextTranslate name="word-terms-conditions" fallback="Terms & Conditions" />
                            </NavLink>
                        </li> */}
                        <li>
                            <a
                                // activeClassName="active"
                                href="https://www.neom.com/en-us/privacy-policy"
                                target="_blank">
                                <TextTranslate name="word-privacy-policy" fallback="Privacy Policy" />
                            </a>
                        </li>
                        {/* <li>
                            <NavLink
                                activeClassName="active"
                                to="/terms/cookie-policy">
                                <TextTranslate name="word-cookie-policy" fallback="Cookie Policy" />
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                activeClassName="active"
                                to="/contact">
                                <TextTranslate name="word-contact-us" fallback="Contact Us" />
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(Footer));
